// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const DeleteStatusReportDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-deletestatusreportdialogcontainer" */ "./DeleteStatusReportDialogContainer")).then((bundle)=>{
        return {
            default: bundle.DeleteStatusReportDialogContainer
        };
    });
export const LazyDeleteStatusReportDialogContainer = /*#__PURE__*/ lazy(DeleteStatusReportDialogContainerLazyLoader);
